import { Button, Modal } from '@tractian/ui'

import { MatrixActions } from '@/features/matrix/components/matrix-actions'
import { MatrixForm } from '@/features/matrix/components/matrix-form'
import { MatrixPnaNote } from '@/features/matrix/components/matrix-pna-note'
import { MatrixStatus } from '@/features/matrix/components/matrix-status'
import { useMatrixForm } from '@/features/matrix/hooks/use-matrix-form'

export type MatrixToolProps = {
  /** Returns to the dev-tools list. */
  onBack: () => void
}

/**
 * Matrix panel inside the dev-tools modal (Cmd+D → Shift+M): the /matrix
 * surface in the modal's body, with its actions in the modal footer — so Save
 * and Reset stay reachable while the service list scrolls. Saving reloads the
 * page (that is what applies the override), so there is nothing to close here.
 */
export function MatrixTool({ onBack }: MatrixToolProps) {
  const state = useMatrixForm()

  return (
    <>
      <Modal.Body>
        <div className="flex flex-col gap-4">
          <MatrixStatus hasActiveOverride={state.hasActiveOverride} />
          <MatrixForm state={state} />
          <MatrixPnaNote />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="outline" onClick={onBack}>
          ← All tools
        </Button>
        <Modal.FooterActions>
          <MatrixActions state={state} />
        </Modal.FooterActions>
      </Modal.Footer>
    </>
  )
}
